// import { useExhibitorForm } from "./hooks/useExhibitorForm";
// import { useState, useEffect, useRef } from "react";
// // import MediaSection from "./sections/MediaSection";
// // import BasicInfoSection from "./sections/BasicInfoSection";
// // import ContactSection from "./sections/ContactSection";
// // import LocationSection from "./sections/LocationSection";
// // import StallSection from "./sections/StallSection";
// // import ScheduleSection from "./sections/ScheduleSection";
// // import StatusSection from "./sections/StatusSection";
// import { useExhibitorCategory } from "components/exhibitorCategory/hooks/useExhibitorCategory";
// import Alert from "components/common/Alert";
// import PageLayout from "../PageFromLayout";
// import {
//   InputField,
//   SelectField,
//   ImageUploadField,
//   CheckboxField,
//   RichTextEditor,
// } from ".././FormFields";
// import { countries, countryCodeOptions } from "../../utils/countryData";
// import { FiArrowRight } from "react-icons/fi";
// import { getOrganizerById } from "../../api/company.api";
// export default function ExhibitorForm({
//   initialData,
//   onSubmit,
//   onBack,
//   alert,
//   setAlert,
// }) {
//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   const userId = "69579c6190a653b640e65639";

//   const {
//     formData,
//     errors,
//     handleChange,
//     handleFile,
//     handleSubmit,
//     existingLogo,
//     existingBanner,
//   } = useExhibitorForm(initialData, selectedOrganizer, userId, alert, setAlert);

//   const { data, loadCategories } = useExhibitorCategory();
//   const exhibitorOptions =
//     data?.map((c) => ({
//       value: c._id,
//       label: c.name,
//     })) || [];

//   const statusOption = [
//     { value: "active", label: "Active" },
//     { value: "inactive", label: "Inactive" },
//   ];

//   const alertRef = useRef(null);

//   useEffect(() => {
//     if (selectedOrganizer) {
//       loadCategories(selectedOrganizer);
//     }
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {

//         if (!selectedOrganizer) return;
//         console.log("selectedOrganizer",selectedOrganizer)

//         const company = await getOrganizerById(selectedOrganizer);
//         const data = company.data.data;

//         console.log("Company data:", data);

//         // setSelectedOrganizer(data);
//       } catch (error) {
//         console.error("Failed to fetch company:", error);
//       }
//     };

//     fetchCompany();
//     const handleOrganizerChange = (e) => {
//       setSelectedOrganizer(e.detail);
//     };
//     window.addEventListener("companyChanged", handleOrganizerChange);
//     return () =>
//       window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);

//   useEffect(() => {
//     if (alert && alertRef.current) {
//       alertRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   }, [alert]);
//   const pageTitle = initialData ? "Edit Exhibitor" : "Create Exhibitor";

//   const pageSubTitle = initialData
//     ? "Update the exhibitor details below."
//     : "Add a new exhibitor to the platform. Fill in the details below.";

//   return (
//     <PageLayout title={pageTitle} subtitle={pageSubTitle}>
//       <form onSubmit={handleSubmit(onSubmit)} className="card-form">
//         {alert && (
//           <div ref={alertRef} className="scroll-mt-[100px] px-6 pt-3">
//             <Alert type="error" message={alert} onClose={() => setAlert("")} />
//           </div>
//         )}
//         <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
//           <input type="hidden" name="company_id" value={selectedOrganizer} />
//           <input type="hidden" name="created_by" value={userId} />
//           <input type="hidden" name="updated_by" value={userId} />
//           <ImageUploadField
//             label="Banner Image"
//             recommended={
//               <>
//                 Recommended resolution: <b>393 × 219 px</b>. Accepted formats:
//                 JPEG, PNG.
//               </>
//             }
//             preview={
//               existingBanner
//                 ? existingBanner
//                 : formData.bannerImage
//                 ? URL.createObjectURL(formData.bannerImage)
//                 : ""
//             }
//             onUpload={handleFile}
//             // onRemove={() => handleImageRemove("banner", "bannerPreview")}
//             required
//             error={errors.bannerImage}
//             name="bannerImage"
//           />
//           <ImageUploadField
//             label="Logo Image"
//             recommended={
//               <>
//                 Recommended resolution: <b>120 × 40 px</b>. Accepted formats:
//                 JPEG, PNG.
//               </>
//             }
//             preview={
//               existingLogo
//                 ? existingLogo
//                 : formData.logoImage
//                 ? URL.createObjectURL(formData.logoImage)
//                 : ""
//             }
//             onUpload={handleFile}
//             // onRemove={() => handleImageRemove("banner", "bannerPreview")}
//             required
//             error={errors.logoImage}
//             name="logoImage"
//           />

//           {/* <RichTextEditor
//             label="Overview"
//             value={formData.overview}
//             onChange={(htmlContent) =>
//               handleChange({
//                 target: {
//                   name: "overview",
//                   value: htmlContent,
//                 },
//               })
//             }
//             required
//             error={errors.overview}
//             maxChars={500}
//           /> */}

//           {/* <input
//           type="text"
//           name="title"
//           value={data.title}
//           onChange={onChange}
//           disabled={readOnly}
//           className={`w-full rounded-xl border p-3 ${
//             errors.title ? "border-red-400" : "border-gray-300"
//           }`}
//         /> */}
//         </div>
//         <div className="grid grid-cols-1 items-start gap-5 md:grid-cols-2">
//           {/* Left Column Controls */}
//           <div className="flex h-full flex-col justify-between gap-5 md:pb-[18px]">
//             <InputField
//               label="Title"
//               name="title"
//               value={formData.title}
//               onChange={handleChange}
//               placeholder="Enter title"
//               error={errors.title}
//               required
//             />

//             <SelectField
//               label="Exhibitor Category"
//               name="exhibitor_category"
//               value={formData.exhibitor_category}
//               onChange={handleChange}
//               options={exhibitorOptions}
//               placeholder="Search exhibitor..."
//               isSearchable={true}
//               // isDisabled={!formData.companyCountry}
//               required
//               error={errors.exhibitor_category}
//             />
//           </div>

//           {/* Right Column: RichText Editor (Full Column Height) */}
//           <div>
//             <RichTextEditor
//               label="Overview"
//               value={formData.overview}
//               onChange={(htmlContent) =>
//                 handleChange({
//                   target: {
//                     name: "overview",
//                     value: htmlContent,
//                   },
//                 })
//               }
//               required
//               error={errors.overview}
//               maxChars={500}
//             />
//           </div>
//         </div>
//         <div className="grid grid-cols-1 items-start gap-5 md:grid-cols-2">
//           <SelectField
//             label="Phone Number country Code "
//             name="country_code"
//             value={formData.country_code}
//             onChange={handleChange}
//             options={countryCodeOptions}
//             placeholder="Search country code..."
//             isSearchable={true}
//             // isDisabled={!formData.companyCountry}
//             required
//             error={errors.country_code}
//           />

//           <InputField
//             label="Phone Number"
//             name="phone_number"
//             value={formData.phone_number}
//             onChange={handleChange}
//             placeholder="Enter ph"
//             error={errors.phone_number}
//             required
//           />
//           <InputField
//             label="Email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             placeholder="Enter email"
//             error={errors.email}
//             required
//           />
//           <InputField
//             label="Password"
//             name="password"
//             value={formData.password}
//             onChange={handleChange}
//             placeholder="Enter Password"
//             error={errors.password}
//             required
//             type="password"
//           />
//           <InputField
//             label="Website"
//             name="website"
//             value={formData.website}
//             onChange={handleChange}
//             placeholder="Enter website"
//             error={errors.website}
//           />
//           <InputField
//             label="Manager Name"
//             name="manager_name"
//             value={formData.manager_name}
//             onChange={handleChange}
//             placeholder="Enter manager name"
//             error={errors.manager_name}
//           />
//           <InputField
//             label="Manager Email"
//             name="manager_email"
//             value={formData.manager_email}
//             onChange={handleChange}
//             placeholder="Enter manager name"
//             error={errors.manager_email}
//           />
//           <SelectField
//             label="Country"
//             name="country"
//             value={formData.country}
//             onChange={handleChange}
//             options={countries}
//             placeholder="Search country..."
//             isSearchable={true}
//             // isDisabled={!formData.companyCountry}
//             required
//             error={errors.country}
//           />
//           <SelectField
//             label="Status"
//             name="status"
//             value={formData.status}
//             onChange={handleChange}
//             options={statusOption}
//             placeholder="Search status..."
//             isSearchable={true}
//             error={errors.status}
//           />
//           <CheckboxField
//             label={"Eco Friendly"}
//             checked={formData.eco_friendly}
//             onChange={(e) =>
//               handleChange({
//                 target: {
//                   name: "eco_friendly",
//                   value: e.target.checked,
//                 },
//               })
//             }
//           />
//         </div>

//         {/* <MediaSection
//           data={formData}
//           errors={errors}
//           onFileChange={handleFile}
//           existingLogo={existingLogo}
//           existingBanner={existingBanner}
//         />
//         <BasicInfoSection
//           data={formData}
//           errors={errors}
//           onChange={handleChange}
//           exhibitors={data}
//         />
//         <ContactSection
//           data={formData}
//           errors={errors}
//           onChange={handleChange}
//           isEdit={!!initialData}
//         />
//         <LocationSection
//           data={formData}
//           errors={errors}
//           onChange={handleChange}
//         /> */}
//         {/* <StallSection
//         data={formData}
//         errors={errors}
//         onChange={handleChange}
//       />
//       <ScheduleSection
//         data={formData}
//         onChange={handleChange}
//       /> */}
//         {/* <StatusSection data={formData} onChange={handleChange} /> */}
//         <div className="button-div flex justify-between">
//           <button type="button" onClick={onBack} className="btn-cancel">
//             Back
//           </button>
//           <button type="submit" className="btn-primary">
//             <span>{initialData ? "Update Exhibitor" : "Create Exhibitor"}</span>

//             <FiArrowRight size={16} />
//           </button>
//         </div>
//       </form>
//     </PageLayout>
//   );
// }
import { useExhibitorForm } from "./hooks/useExhibitorForm";
import { useState, useEffect, useRef } from "react";
import { useExhibitorCategory } from "components/exhibitorCategory/hooks/useExhibitorCategory";
import Alert from "components/common/Alert";
import PageLayout from "../PageFromLayout";
import {
  InputField,
  SelectField,
  ImageUploadField,
  CheckboxField,
  RichTextEditor,
  PhoneNumberField,
} from ".././FormFields";
import { countries, countryCodeOptions } from "../../utils/countryData";
import { FiArrowRight } from "react-icons/fi";
import { getOrganizerById } from "../../api/company.api";
import ScheduleSection from "./sections/ScheduleSection";
import FormSection from ".././FormSection";

export default function ExhibitorForm({
  initialData,
  onSubmit,
  onBack,
  alert,
  setAlert,
}) {
  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );
  const [eventDates, setEventDates] = useState({ start: null, end: null });
  const [role, setRole] = useState("admin");
  const [loader, setLoader] = useState(false); // 👈 Submit Loader State
  const [userId, setUserId] = useState("");
  const [eventTimings,setEventTimings] = useState([]);
  const {
    formData,
    errors,
    handleChange,
    handleFile,
    handleSubmit,
    setSchedules,
    existingLogo,
    existingBanner,
  } = useExhibitorForm(initialData, selectedOrganizer, userId, alert, setAlert);

  const { data, loadCategories } = useExhibitorCategory();
  const exhibitorOptions =
    data?.map((c) => ({
      value: c._id,
      label: c.name,
    })) || [];

  const statusOption = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const alertRef = useRef(null);

  useEffect(() => {
    if (selectedOrganizer) {
      loadCategories(selectedOrganizer);
    }
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (userData) {
      setRole(userData.role);
      setUserId(userData.userId || userData._id || "");
    }
  }, [selectedOrganizer]);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        if (!selectedOrganizer) return;
        const company = await getOrganizerById(selectedOrganizer);
        const data = company.data;
        setEventTimings(data?.eventTimings ||[])
        if (data.eventStartDate && data.eventEndDate ) {
          setEventDates({
            start: data.eventStartDate,
            end: data.eventEndDate,
          });
          
        }
      } catch (error) {
        console.error("Failed to fetch company:", error);
      }
    };

    fetchCompany();
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };
    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, [selectedOrganizer]);

  // Wrapped Submit Handler to control Loader state
  const onFormSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      // Run hook's validation/submission handler
      const submitHandler = handleSubmit(onSubmit);
      await submitHandler(e);
    } catch (err) {
      console.error("Form submission error:", err);
    } finally {
      setLoader(false);
    }
  };

  return (
    <PageLayout
      onBack={onBack}
      onSubmit={onFormSubmit}
      submitText={initialData ? "Update Exhibitor" : "Create"}
      loading={loader}
    >
      <form onSubmit={onFormSubmit} className="flex flex-col gap-6">
        {alert && (
          <div ref={alertRef} className="scroll-mt-[100px] px-6 pt-3">
            <Alert type="error" message={alert} onClose={() => setAlert("")} />
          </div>
        )}

        <FormSection title="Exhibitor Details">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <input type="hidden" name="company_id" value={selectedOrganizer} />
            <input type="hidden" name="created_by" value={userId} />
            <input type="hidden" name="updated_by" value={userId} />
            <InputField
              label="Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter title"
              error={errors.title}
              required
            />

            <SelectField
              label="Exhibitor Category"
              name="exhibitor_category"
              value={formData.exhibitor_category}
              onChange={handleChange}
              options={exhibitorOptions}
              placeholder="Search exhibitor..."
              isSearchable={true}
              required
              error={errors.exhibitor_category}
            />

            <RichTextEditor
              label="Overview"
              value={formData.overview}
              onChange={(htmlContent) =>
                handleChange({
                  target: { name: "overview", value: htmlContent },
                })
              }
              required
              error={errors.overview}
              maxChars={500}
            />
          </div>
        </FormSection>
        <FormSection title="Exhibitor Media">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <ImageUploadField
              label="Banner Image"
              recommended={
                <>
                  Recommended resolution: <b>393 × 219 px</b>. Accepted formats:
                  JPEG, PNG.
                </>
              }
              preview={
                existingBanner
                  ? existingBanner
                  : formData.bannerImage
                  ? URL.createObjectURL(formData.bannerImage)
                  : ""
              }
              onUpload={handleFile}
              required
              error={errors.bannerImage}
              name="bannerImage"
              accept="image/jpeg, image/png, image/webp, image/heic, image/heif, .heic, .heif"
            />

            <ImageUploadField
              label="Logo Image"
              recommended={
                <>
                  Recommended resolution: <b>120 × 40 px</b>. Accepted formats:
                  JPEG, PNG.
                </>
              }
              preview={
                existingLogo
                  ? existingLogo
                  : formData.logoImage
                  ? URL.createObjectURL(formData.logoImage)
                  : ""
              }
              onUpload={handleFile}
              required
              error={errors.logoImage}
              name="logoImage"
              accept="image/jpeg, image/png, image/webp, image/heic, image/heif, .heic, .heif"
            />
          </div>
        </FormSection>

        <FormSection title="Contect Details">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <PhoneNumberField
              label="Phone Number"
              name="phone_number"
              codeName="companyMobileCountryCode"
              phoneValue={formData.phone_number}
              codeValue={formData.country_code}
              onChange={handleChange}
              onCodeChange={(val) => {
                // Wrap inside target so handleChange can safely destructure e.target
                handleChange({ target: { name: "country_code", value: val } });
              }}
              options={countryCodeOptions}
              placeholder="712 345 678"
              required
              error={errors.phone_number}
            />

            <InputField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              error={errors.email}
              required
            />

            <InputField
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter Password"
              error={errors.password}
              required
              type="password"
            />
            <InputField
              label="Manager Name"
              name="manager_name"
              value={formData.manager_name}
              onChange={handleChange}
              placeholder="Enter manager name"
              error={errors.manager_name}
            />

            <InputField
              label="Manager Email"
              name="manager_email"
              value={formData.manager_email}
              onChange={handleChange}
              placeholder="Enter manager email"
              error={errors.manager_email}
            />
            <InputField
              label="Website"
              name="website"
              value={formData.website}
              onChange={handleChange}
              placeholder="Enter website"
              error={errors.website}
            />
          </div>
        </FormSection>

        <FormSection title="Location & Status">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <SelectField
              label="Country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              options={countries}
              placeholder="Search country..."
              isSearchable={true}
              required
              error={errors.country}
            />

            <SelectField
              label="Status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              options={statusOption}
              placeholder="Search status..."
              isSearchable={true}
              error={errors.status}
            />

            <InputField
              label="Hall No"
              name="hallNo"
              value={formData.hallNo}
              onChange={handleChange}
              placeholder="Enter hallNo"
              error={errors.hallNo}
            />

            <div className="pt-6">
              <CheckboxField
                label={"Eco Friendly"}
                checked={formData.eco_friendly}
                onChange={(e) =>
                  handleChange({
                    target: { name: "eco_friendly", value: e.target.checked },
                  })
                }
              />
            </div>
          </div>
        </FormSection>

        {/* Schedule Section tied to formData state */}
        {/* {role === "exhibitor" && (
          <FormSection title="Appointment Schedule Setup ">
            <ScheduleSection
              schedules={formData.schedules}
              setSchedules={setSchedules}
              eventStartDate={eventDates.start}
              eventEndDate={eventDates.end}
              eventSchedules = {eventTimings}
            />
          </FormSection>
        )} */}
      </form>
    </PageLayout>
  );
}
